import { createStateHook, type HookStateFunction } from 'react-sweet-state';

import type { ErrorState } from '../../actions/errors/types';
import { store } from '../../main';
import type { IssueAdjustmentsState } from '../../types';

export const useError: HookStateFunction<ErrorState | null, void> = createStateHook(store, {
	selector: (state: IssueAdjustmentsState) => state.error,
});
